import { createEntityAdapter } from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';

import { RequestStatus } from '@app/types';
import { GetSideMenuResponse } from '@app/gen/side_menu';
import {
  ContentSearchRequest,
  ContentSearchResponse,
  ContentSearchGroupsResponse,
} from '@app/gen/search';

import { SIDEBAR_STATE_LOCAL_STORAGE_KEY } from '../constants';

export interface LayoutState {
  isServiceUnavailable: boolean;
  isRefreshing: boolean;
  sidebarState: boolean;
  sideMenuState: GetSideMenuResponse | null;
  isLogoLoaded: boolean;
  search: {
    status: RequestStatus;
    group: ContentSearchRequest['group'];
    items: ContentSearchResponse | null;
    error: AppError | null;
  };

  logoLoadingStatus: RequestStatus;
  logoLoadingError: AppError | null;

  sideMenuStatus: RequestStatus;
  sideMenuError: AppError | null;

  groups: {
    status: RequestStatus;
    error: AppError | null;
    items: ContentSearchGroupsResponse['search_groups'] | null;
  };
}

const loadSidebarStateFromLocalStorage = (): boolean => {
  try {
    const sidebarState = localStorage.getItem(SIDEBAR_STATE_LOCAL_STORAGE_KEY);

    return typeof sidebarState === 'string' ? sidebarState === 'true' : true;
  } catch {
    return true;
  }
};

export const initialState: LayoutState = {
  isServiceUnavailable: false,
  isRefreshing: false,
  sidebarState: loadSidebarStateFromLocalStorage(),
  sideMenuState: null,
  isLogoLoaded: false,
  search: {
    status: 'idle',
    group: undefined,
    items: null,
    error: null,
  },
  logoLoadingStatus: 'idle',
  logoLoadingError: null,

  sideMenuStatus: 'idle',
  sideMenuError: null,

  groups: {
    status: 'idle',
    error: null,
    items: null,
  },
};
export const layoutAdapter = createEntityAdapter();
